


// import React, { useState, useEffect } from 'react';
// import { toast } from 'sonner';
// import { css } from '@emotion/react';
// import { ClipLoader } from 'react-spinners';
// import { Pie } from 'react-chartjs-2';
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
// import AdminActions from './AdminActions';

// ChartJS.register(ArcElement, Tooltip, Legend);

// const override = css`
//   display: block;
//   margin: 0 auto;
// `;

// const JobStatistics = () => {
//   const [jobs, setJobs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [page, setPage] = useState(1);
//   const limit = 10; 
//   const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3008/api/v1/';

//   useEffect(() => {
//     const fetchJobs = async () => {
//       try {
//         const response = await fetch(`${apiUrl}job/allJob?page=${page}&limit=${limit}`, {
//           method: 'GET',
//           headers: {
//             'Authorization': `Bearer ${localStorage.getItem('token')}`,
//           },
//         });
//         const data = await response.json();
//         if (response.ok) {
//           setJobs(data.data || []); // Adjust based on response structure
//         } else {
//           toast.error(data.message || 'Failed to fetch jobs');
//         }
//       } catch (error) {
//         console.error('Fetch Error:', error);
//         toast.error('An error occurred while fetching jobs');
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchJobs();
//   }, [apiUrl, page]);

//   const filteredJobs = jobs.filter(job =>
//     `${job.industry} ${job.jobTitle} ${job.state}`.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   // Process data by industry, state, and month
//   const processJobData = () => {
//     const monthlyStats = {};
//     filteredJobs.forEach(job => { // Use filteredJobs instead of jobs for accurate stats
//       const month = new Date(job.createdAt).toLocaleString('default', { month: 'long', year: 'numeric' });
//       const key = `${job.industry}-${job.state}-${month}`;
//       if (!monthlyStats[key]) {
//         monthlyStats[key] = { totalJobs: 0, totalApplicants: 0, employedApplicants: 0 };
//       }
//       monthlyStats[key].totalJobs += 1;
//       monthlyStats[key].totalApplicants += (job.numberOfApplicant?.length || 0);
//       // Check applications for 'Accepted' status
//       const employed = job.applications?.filter(app => app?.status === 'Accepted') || [];
//       monthlyStats[key].employedApplicants += employed.length;
//     });

//     return monthlyStats;
//   };

//   const jobData = processJobData();
//   const industries = [...new Set(filteredJobs.map(job => job.industry))]; // Use filteredJobs
//   const states = [...new Set(filteredJobs.map(job => job.state))]; // Use filteredJobs

//   // Pie chart data for total jobs by industry
//   const jobPieData = {
//     labels: industries,
//     datasets: [{
//       data: industries.map(industry => filteredJobs.filter(j => j.industry === industry).length), // Use filteredJobs
//       backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40'],
//       hoverOffset: 4,
//     }],
//   };

//   // Pie chart data for employed applicants by industry
//   const employedPieData = {
//     labels: industries,
//     datasets: [{
//       data: industries.map(industry => 
//         Object.values(jobData).filter(stat => stat.industry === industry).reduce((sum, stat) => sum + stat.employedApplicants, 0)
//       ),
//       backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40'],
//       hoverOffset: 4,
//     }],
//   };

//   // Pie chart data for jobs by state and month
//   const stateMonthPieData = {
//     labels: states.map(state => `${state} (${new Date().toLocaleString('default', { month: 'long', year: 'numeric' })})`), // Current month-year as example
//     datasets: [{
//       data: states.map(state => filteredJobs.filter(j => j.state === state).length),
//       backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0'],
//       hoverOffset: 4,
//     }],
//   };

//     const chartOptions = {
//     plugins: {
//       legend: {
//         labels: {
//           generateLabels: (chart) => {
//             const data = chart.data;
//             return data.labels.map((label, index) => ({
//               text: label,
//               fillStyle: data.datasets[0].backgroundColor[index],
//               strokeStyle: '#fff',
//               lineWidth: 1,
//               hidden: !chart.getDataVisibility(index),
//               index,
//               // Apply Tailwind-inspired inline styles
//               font: {
//                 size: 14,
//                 family: 'Arial',
//                 style: 'normal',
//                 weight: '500', // Equivalent to font-semibold
//               },
//               padding: 10,
//               boxWidth: 20,
//               boxHeight: 20,
//               color: '#fff', 
//             }));
//           },
//           usePointStyle: true,
//         },
//       },
//     },
//   };


//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-screen bg-gray-900">
//         <ClipLoader color="#f97316" css={override} size={50} />
//       </div>
//     );
//   }

//   return (
//     <div className="p-6 bg-gray-900 min-h-screen text-white">
//       <h1 className="text-3xl font-bold mb-6 text-orange-500">Job Statistics - {jobs.length > 0 ? jobs.length : 0} jobs</h1>
//       <div className="mb-6 flex items-center">
//         <input
//           type="text"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//           placeholder="Search by industry, job title, or state..."
//           className="p-3 border border-gray-700 rounded-md w-full md:w-1/3 bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500"
//         />
//         <button
//           onClick={() => setPage(prev => prev + 1)}
//           className="ml-4 p-2 bg-orange-500 text-white rounded hover:bg-orange-600"
//           disabled={jobs.length < limit}
//         >
//           Next Page
//         </button>
//       </div>
//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
//         <div className="overflow-x-auto shadow-lg rounded-lg">
//           <table className="w-full bg-gray-800 border-collapse">
//             <thead>
//               <tr className="bg-gray-700">
//                 <th className="border-b border-gray-600 p-4 text-left text-orange-400">Industry</th>
//                 <th className="border-b border-gray-600 p-4 text-left text-orange-400">State</th>
//                 <th className="border-b border-gray-600 p-4 text-left text-orange-400">Month</th>
//                 <th className="border-b border-gray-600 p-4 text-left text-orange-400">Job Title</th>
//                 <th className="border-b border-gray-600 p-4 text-left text-orange-400">Total Jobs</th>
//                 <th className="border-b border-gray-600 p-4 text-left text-orange-400">Total Applicants</th>
//                 <th className="border-b border-gray-600 p-4 text-left text-orange-400">Employed Applicants</th>
//               </tr>
//             </thead>
//             <tbody>
//               {Object.entries(jobData).map(([key, stat]) => {
//                 const [industry, state, month] = key.split('-');
//                 // Find a representative job title (using the first job for this key)
//                 const sampleJob = filteredJobs.find(job => 
//                   `${job.industry}-${job.state}-${new Date(job.createdAt).toLocaleString('default', { month: 'long', year: 'numeric' })}` === key
//                 );
//                 const jobTitle = sampleJob ? sampleJob.jobTitle : 'N/A';
//                 return (
//                   <tr key={key} className="border-b border-gray-600 hover:bg-gray-700 transition-colors">
//                     <td className="border-r border-gray-600 p-4">{industry}</td>
//                     <td className="border-r border-gray-600 p-4">{state}</td>
//                     <td className="border-r border-gray-600 p-4">{month}</td>
//                     <td className="border-r border-gray-600 p-4">{jobTitle}</td>
//                     <td className="border-r border-gray-600 p-4">{stat.totalJobs}</td>
//                     <td className="border-r border-gray-600 p-4">{stat.totalApplicants}</td>
//                     <td className="border-r border-gray-600 p-4">{stat.employedApplicants}</td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//           <div className="bg-gray-800 text-white p-4 rounded-lg shadow-lg">
//             <h2 className="text-xl font-semibold text-orange-500 mb-2">Jobs by State (This Month)</h2>
//             <div className="w-1/2 mx-auto"> {/* Reduce size to half width */}
//               <Pie data={stateMonthPieData}  option={chartOptions} />
              
//             </div>
//             <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
//             <h2 className="text-xl font-semibold text-orange-500 mb-4">Total Jobs by Industry</h2>
//              <div className="w-2/3 mx-auto">
//             <Pie data={jobPieData} />
//             </div>
//           </div>
//           </div>
//         <div className="grid grid-cols-1 gap-6">
          
//           <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
//             <h2 className="text-xl font-semibold text-orange-500 mb-4">Employed Applicants by Industry</h2>
//             <Pie data={employedPieData} />
//           </div>
        
//         </div>
//       </div>
//     </div>
//   );
// };

// export default JobStatistics;









import React, { useState, useEffect, useMemo } from 'react';
import { toast } from 'sonner';
import { ClipLoader } from 'react-spinners';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Search, ChevronLeft, ChevronRight, Briefcase, Users, UserCheck } from 'lucide-react';

ChartJS.register(ArcElement, Tooltip, Legend);

// Updated Light Theme Chart Options
const CHART_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        usePointStyle: true,
        pointStyle: 'circle',
        boxWidth: 8,
        boxHeight: 8,
        padding: 14,
        color: '#374151',
        font: { size: 12, family: 'inherit', weight: '500' },
      },
    },
    tooltip: {
      backgroundColor: '#1F2937',
      titleColor: '#F3F4F6',
      bodyColor: '#F3F4F6',
      borderColor: '#4B5563',
      borderWidth: 1,
      padding: 10,
      displayColors: true,
    },
  },
};

const PALETTE = ['#F97316', '#3B82F6', '#10B981', '#8B5CF6', '#EC4899', '#F59E0B'];

const StatPill = ({ icon: Icon, label, value }) => (
  <div className="flex items-center gap-3 rounded-xl bg-white border border-gray-200 px-4 py-3 min-w-[150px] shadow-sm">
    <div className="flex items-center justify-center w-9 h-9 rounded-lg bg-orange-100 text-orange-600 shrink-0">
      <Icon size={18} strokeWidth={2} />
    </div>
    <div className="min-w-0">
      <p className="text-xs uppercase tracking-wide text-gray-500 leading-tight">{label}</p>
      <p className="text-lg font-semibold text-gray-900 leading-tight truncate">{value}</p>
    </div>
  </div>
);

const ChartCard = ({ title, data, totalLabel }) => {
  const hasData = data.datasets[0].data.some((v) => v > 0);

  return (
    <div className="rounded-xl bg-white border border-gray-200 p-5 flex flex-col shadow-sm h-full">
      <h3 className="text-sm font-semibold text-gray-900 mb-4">{title}</h3>
      <div className="flex-1 flex items-center justify-center min-h-[260px]">
        {hasData ? (
          <div className="w-full max-w-[280px] aspect-square">
            <Pie data={data} options={CHART_OPTIONS} />
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center gap-3 py-12 text-center">
            <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center">
              <Briefcase size={24} className="text-gray-400" />
            </div>
            <p className="text-gray-500">No {totalLabel} to show yet</p>
          </div>
        )}
      </div>
    </div>
  );
};

const JobStatistics = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(1);
  const limit = 10;
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3008/api/v1/';

  useEffect(() => {
    let isMounted = true;
    const fetchJobs = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${apiUrl}job/allJob?page=${page}&limit=${limit}`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        const data = await response.json();
        if (!isMounted) return;
        if (response.ok) {
          setJobs(data.data || []);
        } else {
          toast.error(data.message || 'Failed to fetch jobs');
        }
      } catch (error) {
        console.error('Fetch Error:', error);
        if (isMounted) toast.error('An error occurred while fetching jobs');
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    fetchJobs();
    return () => { isMounted = false; };
  }, [apiUrl, page]);

  const filteredJobs = useMemo(() => 
    jobs.filter((job) =>
      `${job.industry} ${job.jobTitle} ${job.state}`
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    ), [jobs, searchTerm]
  );

  const jobData = useMemo(() => {
    const monthlyStats = {};
    filteredJobs.forEach((job) => {
      const month = new Date(job.createdAt).toLocaleString('default', {
        month: 'long',
        year: 'numeric',
      });
      const key = `${job.industry}-${job.state}-${month}`;
      if (!monthlyStats[key]) {
        monthlyStats[key] = {
          industry: job.industry,
          state: job.state,
          month,
          jobTitle: job.jobTitle,
          totalJobs: 0,
          totalApplicants: 0,
          employedApplicants: 0,
        };
      }
      monthlyStats[key].totalJobs += 1;
      monthlyStats[key].totalApplicants += job.numberOfApplicant?.length || 0;
      const employed = job.applications?.filter((app) => app?.status === 'Accepted') || [];
      monthlyStats[key].employedApplicants += employed.length;
    });
    return monthlyStats;
  }, [filteredJobs]);

  const industries = useMemo(() => 
    [...new Set(filteredJobs.map((job) => job.industry))].filter(Boolean), 
    [filteredJobs]
  );

  const states = useMemo(() => 
    [...new Set(filteredJobs.map((job) => job.state))].filter(Boolean), 
    [filteredJobs]
  );

  const totalApplicants = filteredJobs.reduce(
    (sum, job) => sum + (job.numberOfApplicant?.length || 0), 0
  );
  const totalEmployed = filteredJobs.reduce(
    (sum, job) => sum + (job.applications?.filter((app) => app?.status === 'Accepted').length || 0), 0
  );

  const jobPieData = {
    labels: industries,
    datasets: [{
      data: industries.map((industry) =>
        filteredJobs.filter((j) => j.industry === industry).length
      ),
      backgroundColor: PALETTE,
      borderColor: '#ffffff',
      borderWidth: 2,
      hoverOffset: 6,
    }],
  };

  const employedPieData = {
    labels: industries,
    datasets: [{
      data: industries.map((industry) =>
        Object.values(jobData)
          .filter((stat) => stat.industry === industry)
          .reduce((sum, stat) => sum + stat.employedApplicants, 0)
      ),
      backgroundColor: PALETTE,
      borderColor: '#ffffff',
      borderWidth: 2,
      hoverOffset: 6,
    }],
  };

  const stateMonthPieData = {
    labels: states,
    datasets: [{
      data: states.map((state) => filteredJobs.filter((j) => j.state === state).length),
      backgroundColor: PALETTE,
      borderColor: '#ffffff',
      borderWidth: 2,
      hoverOffset: 6,
    }],
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-50">
        <div className="flex flex-col items-center gap-3">
          <ClipLoader color="#F97316" size={44} />
          <p className="text-sm text-gray-500">Loading job statistics…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 text-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
          <div>
            <h1 className="text-3xl font-bold tracking-tight text-gray-900">
              Job Statistics
            </h1>
            <p className="text-gray-600 mt-1">
              Overview of postings, applicants, and placements
            </p>
          </div>
          <div className="flex gap-3 overflow-x-auto pb-2 sm:pb-0">
            <StatPill icon={Briefcase} label="Jobs" value={filteredJobs.length} />
            <StatPill icon={Users} label="Applicants" value={totalApplicants} />
            <StatPill icon={UserCheck} label="Employed" value={totalEmployed} />
          </div>
        </div>

        {/* Controls */}
        <div className="flex flex-col sm:flex-row gap-4 mb-8">
          <div className="relative flex-1">
            <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search by industry, job title, or state…"
              className="w-full pl-11 pr-4 py-3 rounded-xl bg-white border border-gray-200 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all"
            />
          </div>

          <div className="flex items-center gap-2 self-end sm:self-auto">
            <button
              onClick={() => setPage((prev) => Math.max(1, prev - 1))}
              disabled={page === 1}
              className="flex items-center justify-center w-10 h-10 rounded-xl bg-white border border-gray-200 text-gray-500 hover:text-gray-700 hover:border-gray-300 disabled:opacity-40 transition-colors"
            >
              <ChevronLeft size={18} />
            </button>
            <span className="text-sm text-gray-600 min-w-[64px] text-center tabular-nums px-2">
              Page {page}
            </span>
            <button
              onClick={() => setPage((prev) => prev + 1)}
              disabled={jobs.length < limit}
              className="flex items-center justify-center w-10 h-10 rounded-xl bg-white border border-gray-200 text-gray-500 hover:text-gray-700 hover:border-gray-300 disabled:opacity-40 transition-colors"
            >
              <ChevronRight size={18} />
            </button>
          </div>
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-1 xl:grid-cols-12 gap-6">
          {/* Table Section */}
          <div className="xl:col-span-7 rounded-2xl bg-white border border-gray-200 overflow-hidden shadow-sm">
            <div className="px-6 py-4 border-b border-gray-200">
              <h2 className="text-lg font-semibold text-gray-900">
                Breakdown by Industry & State
              </h2>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="text-left text-xs uppercase tracking-wider text-gray-500 bg-gray-50">
                    <th className="px-6 py-4 font-medium whitespace-nowrap">Industry</th>
                    <th className="px-6 py-4 font-medium whitespace-nowrap">State</th>
                    <th className="px-6 py-4 font-medium whitespace-nowrap">Month</th>
                    <th className="px-6 py-4 font-medium whitespace-nowrap">Job Title</th>
                    <th className="px-6 py-4 font-medium whitespace-nowrap text-right">Jobs</th>
                    <th className="px-6 py-4 font-medium whitespace-nowrap text-right">Applicants</th>
                    <th className="px-6 py-4 font-medium whitespace-nowrap text-right">Employed</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {Object.entries(jobData).length === 0 ? (
                    <tr>
                      <td colSpan={7} className="px-6 py-16 text-center text-gray-500">
                        No jobs match your search.
                      </td>
                    </tr>
                  ) : (
                    Object.entries(jobData).map(([key, stat]) => (
                      <tr key={key} className="hover:bg-gray-50 transition-colors">
                        <td className="px-6 py-4 whitespace-nowrap font-medium">{stat.industry}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-gray-600">{stat.state}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-gray-600">{stat.month}</td>
                        <td className="px-6 py-4 whitespace-nowrap">{stat.jobTitle || 'N/A'}</td>
                        <td className="px-6 py-4 text-right tabular-nums font-medium">{stat.totalJobs}</td>
                        <td className="px-6 py-4 text-right tabular-nums">{stat.totalApplicants}</td>
                        <td className="px-6 py-4 text-right tabular-nums text-orange-600 font-semibold">
                          {stat.employedApplicants}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Charts Section */}
          <div className="xl:col-span-5 grid grid-cols-1 sm:grid-cols-2 gap-6">
            <ChartCard title="Jobs by State" data={stateMonthPieData} totalLabel="state data" />
            <ChartCard title="Jobs by Industry" data={jobPieData} totalLabel="industry data" />
            <div className="sm:col-span-2">
              <ChartCard
                title="Employed Applicants by Industry"
                data={employedPieData}
                totalLabel="employment data"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobStatistics;